import React, { useState } from "react";
import { FaBars } from "react-icons/fa";
import { SideNavbar } from "./SideNavbar";
import logo from "../../images/55-logo.webp";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";

const Navbar = () => {
    const { websiteLoginData } = useSelector((state) => state.user);
    const [openSidenav, setOpenSidenav] = useState(false);
    const className = "text-white flex justify-center items-center border border-[#eadfdf] rounded-[50%] text-center w-[35px] line-clamp-[35px] h-[35px]"
    return (
        <>
            <header className="bg-red-500 flex justify-between items-center paddingX py-2">
                {/* Left Section */}
                <div className="flex items-center justify-center">
                    {/* Menu Icon */}
                    <button className="text-white text-2xl" onClick={() => setOpenSidenav(true)}>
                        <FaBars />
                    </button>
                    {/* Logo */}
                    <Link to='/' className="ml-4">
                        <img
                            src={websiteLoginData.header_logo ? websiteLoginData.header_logo : logo}
                            alt="Logo"
                            className="h-12 object-contain"
                        />
                    </Link>
                </div>

                {/* Right Section */}
                <div className="flex items-center space-x-4">
                    <Link to={websiteLoginData.whatsapp_link ? websiteLoginData.whatsapp_link : "/"} target="_blank" className={`${className}`}>
                        <i className="fa-brands fa-whatsapp fa-beat-fade"></i>
                    </Link>
                    <Link to={websiteLoginData.telegram_link ? websiteLoginData.telegram_link : "/"} target="_blank" className={`${className}`}>
                        <i className="fa-brands fa-telegram fa-beat-fade"></i>
                    </Link>
                    <Link to='/gift' className={`${className}`}>
                        <i className="fa-solid fa-gift fa-bounce"></i>
                    </Link>
                </div>
            </header>

            <SideNavbar openSidenav={openSidenav} setOpenSidenav={setOpenSidenav} />
        </>
    );
};

export default Navbar;
